export default "__VITE_ASSET__CX45IPP6__"